import { componentStyles } from "./live-board-open-button.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureComponent from "/components/core/picture/picture-component";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { LIVE_BOARD_OPEN_BUTTON_HOVERED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";

const liveBoardOpenButton = (props) => {
  const { onClick, liveBoardOpenButtonCtaText, translate, buttonOnMouseEnter, buttonOnMouseLeave } = props;
  const BOARD_IMAGE =
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/button/board_button.png";
  const POINTER_IMAGE =
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/button/arrow_button.svg";

  const onButtonMouseEnter = () => {
    buttonOnMouseEnter();
    trackEvent(LIVE_BOARD_OPEN_BUTTON_HOVERED);
  };

  return (
    <div
      className="live-board-open-button"
      onClick={onClick}
      onMouseEnter={onButtonMouseEnter}
      onMouseLeave={buttonOnMouseLeave}
    >
      <div className="button-text">
        <Paragraph body={liveBoardOpenButtonCtaText || translate("liveBoard.openButton")} />
      </div>
      <div className="button-right-section">
        <div className="board-image-wrapper">
          <PictureComponent src={BOARD_IMAGE} />
          <div className="pulse-circle">
            <div className="pointer-wrapper">
              <PictureComponent src={POINTER_IMAGE} />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(liveBoardOpenButton);
